// @flow
import React from 'react';
import { h, render, Component } from 'preact';

export default class ListField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue || null,
    };
  }

  renderChoices = (value) => (
     <option
       value={value}
       selected={this.state.value === value}
     >
       {value}
     </option>
  );

  render() {
    const {
      name,
      defaultData,
      description,
    } = this.props.formfield;

    const multipleChoices = this.props.data ? this.props.data.split(';') : defaultData.split(';');

    const choices = multipleChoices.map(this.renderChoices);

    const placeholder = `${description}${this.props.required ? '*' : ''}`;

    return (
      <div
        id={this.props.fieldId}
        className={`listfieldBlock ${name}`}
      >
        <label>{description}{this.props.required ? '*' : ''}</label>
        <select
          id={`formfield_${name}`}
          className={`listfield ${name}`}
          onChange={this.onChange}
          required={this.props.required}
        >
          <option
            style={{display: 'none'}}
            disabled
            value=""
            selected={!this.state.value}
          >
            {placeholder}
          </option>
          {choices}
        </select>
      </div>
    );
  }

  onChange = (e) => {
    if (e && e.target) {

      this.props.handleFieldChange(this.props.formfield.name, e.target.value);
      this.setState({ value: e.target.value });
    }
  }
}
